import LiftlogicResourcePage from '../LiftlogicResourcePage';
import MenuItemsContent from './MenuItemsContent';

const MenuItemsPage = () => {
  return (
    <LiftlogicResourcePage title="Menu Items" showTenantSelector>
      {({ selectedTenantId }) =>
        selectedTenantId ? <MenuItemsContent tenantId={selectedTenantId} /> : null
      }
    </LiftlogicResourcePage>
  );
};

export default MenuItemsPage;
